import { render, staticRenderFns } from "./LoyaltyItem.vue?vue&type=template&id=37d75c5c"
import script from "./LoyaltyItem.vue?vue&type=script&lang=ts"
export * from "./LoyaltyItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports